export default {"src":"/_next/static/media/personal.0f6cd2ed.svg","height":80,"width":80};